module.exports = __webpack_public_path__ + "be6aa0de71fd9d15e5f92d679177ea03.png";